import { BeneficialOwners, BeneficialOwnersView } from '../../types/BeneficialOwners';
import { CustomerInstantLease } from '../../types/CustomerInstantLease';
import { Address } from '../../types/AuthorizedRepresentative';

export default function transformBeneficialOwners(data: CustomerInstantLease): BeneficialOwnersView[] {
    function getPostalWithLocality(address: Address | undefined) {
        if (address?.postalCode && address?.city) {
            return address?.postalCode + ' ' + address?.city;
        }
        return undefined;
    }

    if (data?.beneficialOwners) {
        return data?.beneficialOwners.map((value) => {
            return {
                firstName: value?.person?.firstName || 'n/a',
                lastName: value?.person?.lastName || 'n/a',
                location: getPostalWithLocality(value.person?.contactDetails?.addresses[0]) || 'n/a',
            };
        });
    }
    return [];
}
